import { Drawer } from "antd"
import { CloseIcon } from "icons"
import styles from "./index.module.css"
import PropTypes from "prop-types"

const CustomDrawer = ({ open, setOpen, title, children, destroyOnClose }) => {
  const onCloseDrawer = () => {
    if (open) setOpen(false)
  }
  return (
    <Drawer
      className={styles.drawerWrapper}
      title={title}
      placement="bottom"
      closable={false}
      onClose={onCloseDrawer}
      open={open}
      destroyOnClose={destroyOnClose}
      extra={<CloseIcon width={20} height={20} onClick={onCloseDrawer} className="cursor-pointer" />}
    >
      {children}
    </Drawer>
  )
}

CustomDrawer.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  destroyOnClose: PropTypes.bool
}

CustomDrawer.defaultProps = {
  destroyOnClose: false
}

export default CustomDrawer
